/**
 * The irregular name of this file is intentional - it prevents the Storybook docgen from breaking:
 * https://github.com/styleguidist/react-docgen-typescript/pull/313
 *
 */
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { FormField, LabelPlacement } from '../form-field/form-field';

type SwitchSize = 'small' | 'medium';

export type SwitchProps = {
  size?: SwitchSize;
  label?: React.ReactNode;
  labelPlacement?: LabelPlacement;
  // this shadows the input size attribute defined in React.InputHTMLAttributes
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>;

export const Switch = forwardRef(
  (
    { size = 'medium', label, labelPlacement = 'right', className, ...checkboxProps }: SwitchProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const classNames = classnames(className, 'airtame-switch', `airtame-switch--${size}`);

    return (
      <FormField
        label={label}
        labelPlacement={labelPlacement}
        disabled={checkboxProps.disabled}
        className={classNames}
      >
        <input ref={ref} className="airtame-switch__replaced" type="checkbox" {...checkboxProps} />
        <div className="airtame-switch__input">
          <div className="airtame-switch__mark">
            <span className="airtame-switch__knob" />
          </div>
        </div>
      </FormField>
    );
  }
);

Switch.displayName = 'Switch';
